import Description from 'Components/Description/Description'

export default Description